/* eslint-disable indent */
const hasContext = (context: string) => window.contexts.includes(context);

import widgetsMgr from 'widgets/widgetsMgr';

widgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('account'),
    load: () => Promise.all([
            import(/* webpackChunkName: 'account.som' */ './widgets/account/SOMCancellationForm').then(d => d.default),
            import(/* webpackChunkName: 'account.som' */ './widgets/account/SOMOrderHistoryMgr').then(d => d.default)
        ])
        .then(deps => {
            const [
                SOMCancellationForm,
                SOMOrderHistoryMgr
            ] = deps;

            return {
                listId: 'account.som',
                widgetsDefinition: () => [
                    ['somCancellationForm', SOMCancellationForm, 'ajaxform'],
                    ['orderHistoryMgr', SOMOrderHistoryMgr, 'orderHistoryMgr']
                ]
            };
        })
});
